import React from 'react';
export function Footer() {
  return <footer className="bg-neutral-950 border-t border-neutral-900 py-12 px-4 text-center mt-12" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <div className="text-xl font-bold text-white mb-4" data-id="element-93">
          💪 MEGAPACK™: TU NEGOCIO BAJO CONTROL
        </div>
        <p className="text-neutral-400 mb-8 max-w-md mx-auto" data-id="element-94">
          El sistema de negocio N°1 para freelancers y emprendedores digitales
          en España.
          <br data-id="element-95" />
          <br data-id="element-96" />
          Porque tener un negocio organizado y rentable no debería costarte otro
          año de caos.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-neutral-500 mb-8" data-id="element-97">
          <span data-id="element-98">📧 digipromarket3@gmail.com</span>
          <span className="hidden md:inline" data-id="element-99">·</span>
          <span data-id="element-100">📲 @digi.promarket</span>
        </div>

        <div className="text-xs text-neutral-600 mb-8" data-id="element-101">
          © MegaPack™ Tu Negocio Bajo Control 2026 — Todos los derechos
          reservados. Prohibida la reproducción y redistribución sin
          autorización expresa.
        </div>

        <div className="text-brand-accent/80 font-medium italic" data-id="element-102">
          💪 "El próximo cliente puede ser el primero que llegue por tu sistema,
          no por suerte."
        </div>
      </div>
    </footer>;
}